import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Inner from '../../components/Inner';
import GridGallery from '../../components/GridGallery';
import Title from '../../components/Title';
import { workApi } from '../../api';

export default function WorksByYear() {
  const year = new Date().getFullYear()
  const limit = 100;
  const orderBy = "created_at,desc";

  const { t } = useTranslation();
  const [works, setWorks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWorks = async () => {
      setLoading(true);
      const payload = {
        year,
        limit,
        order_by: orderBy
      }
      const response = await workApi.list(payload);
      setWorks(response);
      setLoading(false);
    };
    fetchWorks();
  }, [year]);

  return (
    <Inner>
      <Title>{t('Works of year') + " " + year}</Title>
      {loading ? (
        <div>{t('Loading...')}</div>
      ) : (
        <GridGallery
          items={works}
        />
      )}
    </Inner>
  );
}
